import loadInvisibleTeasers from './loadTeasers'

export default async function teaserControl(options) {
    options = { url: '/blog', fixedCategory: '', text: true, category: true, ignore: '', ...options };
    const state = {
        page: 1,
        category: options.fixedCategory,
        text: '',
        ignore: options.ignore,
        template: options?.template,
    };
    const url = options.url;

    const teaserElement = document.querySelector('.teaser-container');
    const nextTeaserButton = document.querySelector('.next-teaser');

    const loadTeasers = async function (url, options = {}) {
        const success = await loadInvisibleTeasers(url, teaserElement, options);
        if (!success) return false;
        setTimeout(
            () => teaserElement.querySelectorAll('.invisible')
                .forEach(teaser => teaser.classList.remove('invisible'))
            , 100
        );
        return true;
    }

    nextTeaserButton.addEventListener('click', async () => {
        if (await loadTeasers(url, {...state, page: state.page + 1})) {
            state.page++;
        }
    });

    if (options.text) {
        const textSearch = document.querySelector('.filter-text');
        const textSearchInput = textSearch.querySelector('input');
        state.text = textSearchInput.value;
        const searchText = async function () {
            if (state.text === textSearchInput.value) {
                return;
            }
            state.text = textSearchInput.value;
            teaserElement.innerHTML = '';
            await loadTeasers(url, {...state, refresh: true});
        }

        textSearch.addEventListener('submit', (event) => {
            event.preventDefault();
            textSearchInput.blur();
        })
        textSearchInput.addEventListener('blur', searchText)
    }

    if (options.category) {
        const categoryButtons = document.querySelector('.filter-category');
        const filterCategoryButton = document.querySelector('.filter-category-button');
        const filterCategoryContainer = document.querySelector('.filter-category-container');

        categoryButtons.addEventListener('click', async (event) => {
            const button = event.target;
            if (!(button instanceof HTMLButtonElement)) {
                return;
            }
            state.category = button.id;
            teaserElement.innerHTML = '';
            categoryButtons.querySelectorAll('button')
                .forEach(button => button.classList.remove('icon-check'));
            button.classList.add('icon-check');
            await loadTeasers(url, {...state, refresh: true});
        });

        filterCategoryButton.addEventListener('click', () => {
            filterCategoryContainer.classList.toggle('open');
        });
    }

    const init = async function () {
        await loadTeasers(url, state);
    }
    await init();
}